import { Point } from 'components/site/general/singleSelect/SelectedMarkerV2/Point';
import polylabel from 'polylabel';
import { RefObject, useEffect, useState } from 'react';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';
import { MapRef } from 'react-map-gl';

interface Props {
    xyCoordinates: IXY[];
    mapRef: RefObject<MapRef>;
    color: string;
    onRotate: (rotation: number) => void;
    onRotateEnd: (rotation: number) => void;
}

export const RotatePoint = (props: Props) => {
    const [isRotating, setIsRotating] = useState(false);

    useEffect(() => {
        const container = props.mapRef.current?.getContainer()?.getBoundingClientRect();
        const offsetX = container?.left ?? 0;
        const offsetY = container?.top ?? 0;
        const [centerX, centerY] = polylabel([props.xyCoordinates.map(({ x, y }) => [x, y])]);
        const R2D = 180 / Math.PI;

        const getNewRotation = (currentX: number, currentY: number) => {
            const x = currentX - offsetX - centerX;
            const y = currentY - offsetY - centerY;
            const d = R2D * Math.atan2(y, x);
            const newRotation = d + 90;
            return newRotation;
        };

        function mouseMove(event: MouseEvent) {
            if (isRotating) {
                const newRotation = getNewRotation(event.clientX, event.clientY);
                props.onRotate(newRotation);
                event.preventDefault();
            }
        }

        function mouseUp(event: MouseEvent) {
            if (isRotating) {
                setIsRotating(false);
                const newRotation = getNewRotation(event.clientX, event.clientY);
                props.onRotateEnd(newRotation);
            }
        }

        document.addEventListener('mousemove', mouseMove);
        document.addEventListener('mouseup', mouseUp);

        return () => {
            document.removeEventListener('mousemove', mouseMove);
            document.removeEventListener('mouseup', mouseUp);
        };
    }, [isRotating, props.xyCoordinates]);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                top: -20,
                position: 'relative'
            }}
            onMouseDown={() => {
                setIsRotating(true);
            }}
        >
            <Point
                className={'handle'}
                width={25}
                fontSize={12}
                style={{
                    pointerEvents: 'all',
                    position: 'absolute',
                    top: 0
                }}
                text={''}
                icon={{
                    iconPrefix: 'far',
                    iconName: 'arrows-rotate'
                }}
                color={props.color}
            />
        </div>
    );
};
